'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var Icon;
(function (Icon) {
	Icon['AngleDown'] = 'angle-down';
	Icon['AngleUp'] = 'angle-up';
	Icon['Danger'] = 'times';
	Icon['Info'] = 'info';
	Icon['Success'] = 'success';
	Icon['Warning'] = 'warning';
	Icon['Clear'] = 'times';
	Icon['Close'] = 'times';
	Icon['CaretDown'] = 'caret-down';
	Icon['CaretUp'] = 'caret-up';
	Icon['PlusSquareO'] = 'plus-square-o';
	Icon['MinusSquareO'] = 'minus-square-o';
	Icon['Loading'] = 'spinner';
	Icon['Search'] = 'search';
	Icon['VerticalEllipsis'] = 'ellipsis-v';
})((Icon = exports.Icon || (exports.Icon = {})));
//# sourceMappingURL=icon.types.js.map
